import AngleLeft from '../Icons/AngleLeft'
import BackContainer from '../BackContainer/BackContainer'
import useScreenSize from '../../hooks/screen-size'

export const ModalContainer = ({ children, className, onClick, color = 'dark-blue', secondary, title }) => {
  const { isMobile } = useScreenSize()
  return (
    <div className={`modern-modal-container ${color} ${className}`}>
      <div className="inner-container">
        <div className="text-container">
          <div className="back-title" onClick={() => onClick()}>
            {isMobile ? <AngleLeft color={color} width={20} /> : null}
            <h3 className="text-medium heroic italic uppercase">{title}</h3>
          </div>
          <div className="actual-text">{children}</div>
          <BackContainer secondary={color} color={secondary} goBack={() => onClick()} />
        </div>
      </div>
    </div>
  )
}
